<template>
  <el-dialog :visible="showDialog" width="80%" class="chartDia" @close="close">
    <div slot="title" class="slotTit">平台服务费详情</div>
    <div
      style="margin-bottom:15px;color:#666;text-align:left;display:flex;justify-content:space-between;"
    >
      <span>
        【项目支付金额】计算公式为：终端结算金额×（1+6.75%）。说明：6.75%是完税成本
      </span>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border=""
      style="width: 100%"
      :stripe="true"
      :highlight-current-row="false"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="fullName"
        label="任务月度"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dutyName"
        label="项目名"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="hospitalName"
        label="终端结算金额"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="departmentName"
        label="平台服务费"
      ></el-table-column>
    </el-table>
    <!--分页-->
    <!-- <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="paginationData.pageNum"
      :total="totalElements"
      :page-size="paginationData.pageSize"
      layout="total, prev, pager, next, jumper"
      style="padding:15px"
    ></el-pagination>-->
    <el-button @click="close" type="primary">确认</el-button>
  </el-dialog>
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import { company, spread, exportProjectTaskExcel, academy } from '@/api/ajax';
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  mixins: [pageInation],
  data() {
    return {
      getList: academy.xueshuCustomerList // 获取列表的AJAX
    };
  },
  methods: {
    close() {
      this.$parent.showDetail = false;
    }
  }
};
</script>
